import React from 'react';
import { getFirstName } from "../../helpers/formatting";
import ResourceSubTile from "./ResourceSubTile";

const LettersTile = ({
    currentMyChartUser,
    dashboardData,
    disabled,
    isProxyUser,
    isShowAllUsers,
}) => {

    const letterCount = isShowAllUsers ? dashboardData?.data?.unreadLettersCount : dashboardData?.data?.currentUser?.letters?.unreadCount;

    let letterMsg = 'You have no new letters at this time.';

    if (letterCount && letterCount > 0) {
        letterMsg = isShowAllUsers ? 'Letter(s) available for you or your family.' :
            isProxyUser ? `${currentMyChartUser && currentMyChartUser.displayName ? getFirstName(currentMyChartUser.displayName) : 'Your family'} has a new letter` : 'You have a new letter.';
    } else {
        letterMsg = isShowAllUsers ? 'There are no new letters for your family at this time.' :
            isProxyUser ? `${currentMyChartUser && currentMyChartUser.displayName ? getFirstName(currentMyChartUser.displayName) : 'Your family'} has no new letters at this time.` : 'You have no new letters at this time.';
    }

    return (
        <ResourceSubTile
            className="letters-tile"
            heading="Letters"
            description={letterMsg}
            disabled={disabled}
            count={letterCount}
            url={"/familyselection/letters"}
        />
    );
}

export default LettersTile;
